// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const AssociationSvg = ({ color, height, width }) => (
  <svg
    height={height}
    viewBox="0 0 37 42"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g
      fill={color}
      fillRule="evenodd"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.1"
    >
      <path d="M33.015 9.622l3.81-4.063L32.557 1l-4.533 4.835C26.695 3.615 26.94 1 26.94 1H9.246C9.718 6.85 4.374 10.354 1 9.795v3.386C1 23.93 7.467 37.6 17.912 40.946l.177.055.176-.055C28.712 37.598 35.178 23.93 35.178 13.18V9.796s-1.402-.047-2.163-.173zM35.12 5.56L18.273 23.527l-6.157-6.567 2.562-2.732 3.594 3.835L32.558 2.827l2.56 2.732zm-4.777 6.92s.517 16.063-12.254 23.063C10.89 32.346 6.21 22.126 5.856 14.157c3.47-1.346 6.223-4.283 7.478-7.992h9.493c.318 1.032.827 2.496 1.602 3.512l-6.15 6.567-3.594-3.835-4.274 4.56 7.87 8.392L30.34 12.48zm3.625.7c0 10.27-6.37 23.3-15.88 26.474C8.582 36.48 2.212 23.45 2.212 13.18v-2.117c4.4-.315 7.92-4.08 8.224-8.772H25.75a9.794 9.794 0 001.404 4.474l-1.86 1.984c-.805-1.03-1.58-3.882-1.58-3.882h-11.25c-.376.882-1.572 6.29-7.84 8.362l.008.48c.2 8.71 5.197 19.74 13.236 23.12l.22.093.223-.093c8.18-3.44 13.236-14.96 13.236-23.654V11.18l.487-.52-.007.017a8.076 8.076 0 001.934.37v2.134h.008z" />
      <path d="M33.015 9.622l3.81-4.063L32.557 1l-4.533 4.835C26.695 3.615 26.94 1 26.94 1H9.246C9.718 6.85 4.374 10.354 1 9.795v3.386C1 23.93 7.467 37.6 17.912 40.946l.177.055.176-.055C28.712 37.598 35.178 23.93 35.178 13.18V9.796s-1.402-.047-2.163-.173zM35.12 5.56L18.273 23.527l-6.157-6.567 2.562-2.732 3.594 3.835L32.558 2.827l2.56 2.732zm-4.777 6.92s.517 16.063-12.254 23.063C10.89 32.346 6.21 22.126 5.856 14.157c3.47-1.346 6.223-4.283 7.478-7.992h9.493c.318 1.032.827 2.496 1.602 3.512l-6.15 6.567-3.594-3.835-4.274 4.56 7.87 8.392L30.34 12.48zm3.625.7c0 10.27-6.37 23.3-15.88 26.474C8.582 36.48 2.212 23.45 2.212 13.18v-2.117c4.4-.315 7.92-4.08 8.224-8.772H25.75a9.794 9.794 0 001.404 4.474l-1.86 1.984c-.805-1.03-1.58-3.882-1.58-3.882h-11.25c-.376.882-1.572 6.29-7.84 8.362l.008.48c.2 8.71 5.197 19.74 13.236 23.12l.22.093.223-.093c8.18-3.44 13.236-14.96 13.236-23.654V11.18l.487-.52-.007.017a8.076 8.076 0 001.934.37v2.134h.008z" />
      <path d="M17.8 26.6h1.21v1.29H17.8zm0 3.2h1.21v1.29H17.8zm0 2.4h1.21v1.29H17.8z" />
    </g>
  </svg>
);
AssociationSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default AssociationSvg;
